<script>
import customSelect from 'custom-select';
import productRemains from './../inc/ProductRemains';
export default {
    components: {
        'product-remains': productRemains
        
    },
    mixins: [
    ],
    computed: {
    },
    props: {
        product: {
            requeired: true
        }
    },
    mounted() {
        customSelect('#variable');
        this.choiceItemSelect();
    },
    data() {
        return {
            hasOpenSpoiler: false,
            access_to_remains: window.globalVariables.access_to_remains
        }
    },
    methods: {
        detectOpenSpoiler(event) {
            if (event.target.classList.contains('_spoller-active')) {
                this.hasOpenSpoiler = false;
            } else {
                this.hasOpenSpoiler = true;
            }
        },
        choiceItemSelect() {
            let variable = document.getElementById('variable');
            if (variable) {
                variable.addEventListener("change", function(e) {
                    document.location.href = e.target.value;
                });
            }
        }
    }
}
</script>